import axiosInstance from './axiosConfig';

export const getTournamentsApi = (params) => axiosInstance.get('/tournaments', { params });
export const getTournamentApi = (id) => axiosInstance.get(`/tournaments/${id}`);
export const getPublicTournamentsApi = (params) =>
  axiosInstance.get('/public/tournaments', { params });
export const getPublicTournamentApi = (id) =>
  axiosInstance.get(`/public/tournaments/${id}`);
export const createTournamentApi = (payload) => axiosInstance.post('/tournaments', payload);
export const updateTournamentApi = (id, payload) =>
  axiosInstance.put(`/tournaments/${id}`, payload);
export const getTournamentStandingsApi = (id) => axiosInstance.get(`/tournaments/${id}/standings`);

// ثبت‌نام باشگاه در تورنمنت.
// مدیر باشگاه: بدون payload (یا فقط notes) صدا بزند — باشگاه خودش به‌صورت خودکار استفاده می‌شود.
// ادمین: می‌تواند clubId مشخصی را در payload بفرستد.
export const registerClubToTournamentApi = (tournamentId, payload) =>
  axiosInstance.post(`/tournaments/${tournamentId}/registrations`, payload);

export const updateRegistrationPaymentApi = (tournamentId, registrationId, paymentStatus) =>
  axiosInstance.put(`/tournaments/${tournamentId}/registrations/${registrationId}/payment`, {
    paymentStatus,
  });

// تایید/رد ثبت‌نام باشگاه — فقط ADMIN
export const approveRegistrationApi = (tournamentId, registrationId, approvalNote) =>
  axiosInstance.put(`/tournaments/${tournamentId}/registrations/${registrationId}/approve`, {
    approvalNote,
  });

export const rejectRegistrationApi = (tournamentId, registrationId, approvalNote) =>
  axiosInstance.put(`/tournaments/${tournamentId}/registrations/${registrationId}/reject`, {
    approvalNote,
  });